import { Button, Classes, Dialog, Intent, Switch } from '@blueprintjs/core'
import React from 'react'
import { setInStorage, getFromStorage } from '../../../storage'

export default ({ isOpen, columns, onDialogClose, onEnabledColumnChange, storageKey }) => (
  <Dialog isOpen={isOpen} onClose={onDialogClose} title="Customize Columns">
    <div className={Classes.DIALOG_BODY} style={{ maxHeight: 350, overflowY: 'scroll' }}>
      <table className="bp3-html-table-condensed" style={{ width: '100%', maxWidth: '300px' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Column</th>
            <th style={{ textAlign: 'left' }}>Show Column</th>
          </tr>
        </thead>
        <tbody>
          {columns.map(c => {
            let name = c.Header
            // if the header is blank, default hide it, unless its the thumbnail
            if (!name) {
              if (c.id === 'thumb') name = 'Thumbnail'
              else return null
            }
            return (
              <tr key={c.id}>
                <td>{name}</td>
                <td>
                  <Switch
                    checked={c.show}
                    onChange={e => {
                      const item = getFromStorage(storageKey, true) || {}
                      const enabledColumns = { ...item, [c.id]: e.target.checked }
                      setInStorage(storageKey, enabledColumns, true)
                      onEnabledColumnChange(enabledColumns)
                    }}
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <ul />
    </div>
    <div className={Classes.DIALOG_FOOTER}>
      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
        <Button intent={Intent.PRIMARY} onClick={onDialogClose}>
          Close
        </Button>
      </div>
    </div>
  </Dialog>
)
